module.exports = __webpack_public_path__ + "img/zip.cc54ca03.png";